import React, { useState } from 'react';
import PropTypes from 'prop-types';
import i18n from 'micro-i18n';
import { IconDownCaret } from 'components/icons/Icons';
import { DelayTimer } from 'consts';
import classNames from 'classnames';

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/results/MatrixResultRow.scss';

const MatrixResultRow = ({ row, isActive }) => {
  const { text, options } = row;
  const [isLoaded, setIsLoaded] = useState(false);

  const answeredOption = options && options.find((option) => {
    const { answered } = option;
    return answered;
  });

  setTimeout(() => setIsLoaded(isActive), DelayTimer.ResultItemAnimMS);

  return (
    <div className="csw-r-mtrx-row outline" tabIndex="0"
         aria-label={answeredOption ? i18n.t('RESULT_ANSWERED_MTRX_LBL', {
           percent: answeredOption.percent, text: answeredOption.text
         }) : ''}>

      <div className="csw-r-mtrx-row-top">
        <div className="csw-r-mtrx-o csw-r-mtrx-row-text"
             role="heading"
             aria-level="2">{text}</div>

        {options && options.map((option, index) => {
          const { percent, answered } = option;
          const percentStyle = { height: isNaN(percent) ? 0 : `${isLoaded ? percent : 0}%` };
          const percentClass = `csw-r-mtrx-o-percent-${percent}`;
          const answeredClass = answered ? 'option-answered' : 'option-not-answered';
          const answeredStyle = { bottom: isNaN(percent) ? 0 : `${isLoaded ? percent : 0}%` };

          return (
            <div className={classNames('csw-r-mtrx-o', percentClass)} key={`csw-r-mtrx-o-${index}`}>
              <div className="csw-r-mtrx-o-chart-fill-wrapper">
                <div className={classNames('csw-r-mtrx-o-answer', answeredClass)}
                     style={answeredStyle}>
                  {answered && <IconDownCaret
                    title={i18n.t('YOUR_ANSWER')}
                    role="img"
                    aria-label={i18n.t('YOUR_ANSWER')}
                    aria-hidden="false" />}
                </div>
                <div className="csw-r-mtrx-o-chart-fill" style={percentStyle}>{' '}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="csw-r-mtrx-row-bottom">
        <div className="csw-r-mtrx-o csw-r-mtrx-row-space">{' '}</div>

        {options && options.map((option, index) => {
          const { percent } = option;

          return (
            <div className="csw-r-mtrx-o csw-r-mtrx-o-percent"
                 key={`csw-r-mtrx-o-percent-${index}`}>{percent}%</div>
          );
        })}
      </div>

    </div>
  );
};

MatrixResultRow.propTypes /* remove-proptypes */ = {
  row: PropTypes.object.isRequired,
  isActive: PropTypes.bool
};

export default MatrixResultRow;
